import { UserProfile } from '../types/common.types';

/**
 * Checks if a profile is minimal (incomplete).
 * A profile is considered minimal if it's missing firstName, lastName, or displayName.
 * This typically indicates a user who has registered but not completed onboarding.
 */
export const isMinimalProfile = (profile: Partial<UserProfile>): boolean => {
  return !profile.firstName || !profile.lastName || !profile.displayName;
};
